<template>
    <div :class="{ 'body-centered-window': activedBodyCentered }">
        <div :class="(unstyled)?'unstyled b-toast windows_block':'b-toast windows_block'" :style="((defaultbl)?'position: inherit;':'')+((inProduct)?'right: 0;bottom: 0px;':'')+((active)?'z-index: 10;':'')">
            <div :class="(active)?backColor+' windows active':backColor+' windows'" :style="((defaultbl)?'width: 100%;box-shadow: none;':'')">
                <button v-if="!defaultbl" type="button" class="close ml-auto mb-1" @click="close()">×</button>
                <div class="toast-body" v-if="hasHeaderSlot() && !(this.formSent && hasAgradecimientoSlot)">
                    <slot name="header"></slot>
                </div>
                <div class="toast-footer" v-if="hasFooterSlot()||hasButtonSlot()">
                    <slot name="footer" v-if="hasFooterSlot()"></slot>
                    <div @click="activeFormTrue()" v-if="hasButtonSlot()&&!activeForm && !(this.formSent && hasAgradecimientoSlot)">
                        <slot name="button" v-if="hasButtonSlot()"></slot>
                    </div>
                    <div v-if="activeForm">
                        <load-spiner v-if="loading"></load-spiner>
                        <form v-else>
                            <p>Rellena el siguiente formulario y en breve nos pondremos en contacto.</p>
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="nombre" type="text" :class="'form-element '+((errors['nombre']) ? 'is-invalid' : '')" v-model="form.nombre" placeholder="Nombre">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="movil" type="text" :class="'form-element '+((errors['movil']) ? 'is-invalid' : '')" v-model="form.movil" placeholder="Móvil (opcional)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="email" type="text" :class="'form-element '+((errors['email']) ? 'is-invalid' : '')" v-model="form.email" placeholder="Correo electrónico">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <textarea id="mensaje" :class="'form-element '+((errors['mensaje']) ? 'is-invalid' : '')" v-model="form.mensaje" placeholder="¿En qué podemos ayudarte?"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p>Al envíar el formulario, aceptas los <a href="/terminos-condiciones">términos y
                                condiciones</a> y la <a href="/politica-privacidad">política de privacidad</a>.</p>
                            <div class="bp-form-group">
                                <a class="alter-btn-green" @click="submit()">
                                    <span>Enviar</span>
                                </a>
                            </div>
                        </form>
                    </div>
                    <div v-if="hasAgradecimientoSlot()&&!activeForm && formSent">
                        <slot name="agradecimiento" v-if="hasButtonSlot()"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['backColor','inProduct','articulo','combinacion','inCart', 'defaultbl'],
        data() {
            return {
                active: false,
                activeForm: false,
                formSent: false,
                unstyled: false,
                form: {
                    nombre: "",
                    movil: "",
                    semana: "",
                    producto: "",
                    type: "",
                    email: "",
                    mensaje: ""
                },

                errors: [],
                loading: false,
            }
        },
        computed: {
            bodyCentered() {
                return !!this.inCart;
            },
            activedBodyCentered() {
                return this.bodyCentered && this.active;
            }
        },
        mounted: function () {
            if(this.defaultbl){
                this.active = true;
            }
        },
        methods: {
            close: function () {
                this.active=false;
            },
            hasHeaderSlot() {
                return (this.$slots.header)?true:false;
            },
            hasFooterSlot() {
                return (this.$slots.footer)?true:false;
            },
            activeFormTrue() {
                this.activeForm=true;
            },
            hasButtonSlot() {
                return (this.$slots.button)?true:false;
            },
            hasAgradecimientoSlot() {
                return (this.$slots.agradecimiento)?true:false;
            },
            submit: function () {
                this.loading = true;
                if(this.combinacion){
                    this.form['producto'] = this.articulo.especie_verify.nombre+' '+this.articulo.nombre_verify+'('+this.combinacion.bandeja.unidades+'x'+this.combinacion.semilla_alveolo+')';
                    this.form['type'] = 'contact_out_stock';
                }else if(this.articulo){
                    this.form['producto'] = this.articulo.especie_verify.nombre+' '+this.articulo.nombre_verify;
                    this.form['type'] = 'contact_out_stock';
                }else{
                    this.form['type'] = 'help_contact';
                }

                axios.post(this.route('send.contact'), this.form).then(response => {
                    this.loading = false;
                    this.errors = [];
                    if(!this.defaultbl && !this.hasAgradecimientoSlot()){
                        this.close();
                    }else{
                        this.activeForm=false;
                        this.formSent = true;
                    }
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });

                    this.form = {nombre: "", movil: "", mensaje: ""};
                }).catch(e => {
                    this.loading = false;
                    this.errors = e.response.data.errors;

                    Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error', {
                        type: "error",
                        duration: 3000
                    });

                    console.log(e);
                });
            }
        }
    }
</script>


<style>
.body-centered-window {
    position: fixed;
    inset: -9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
}
</style>
